import { useEffect } from 'react';
import { useSceneStore } from '../stores/sceneStore';

/**
 * Hook to warn users before leaving the page with unsaved changes
 * Shows browser confirmation dialog if scene is dirty
 */
export function useUnsavedChangesWarning() {
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      const isDirty = useSceneStore.getState().isDirty;

      if (isDirty) {
        // Standard way to trigger confirmation dialog
        event.preventDefault();
        // Some browsers require returnValue to be set
        event.returnValue = '';
        return '';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);
}
